import React from 'react';
import PropTypes from 'prop-types';
import BasicQuoteInformation from '../../BasicQuoteInformation/BasicQuoteInformation';
import CrmQuote from '../../../../classes/CrmQuote';

function UnexpectedErrorQuoteScreen({ quote, loadError }) {
  return (
    <div>
      <p>
        Basic information about your order is listed below.
        Additional details and order tracking are restricted by your access.
      </p>
      <div className="row">
        <div className="col-auto mb-2">
          <BasicQuoteInformation
            createdAt={quote.createdAtDisplay}
            quoteNumber={quote.quoteNumber}
            quoteStatus={quote.statusType}
            expiresAt={quote.expiresAtDisplay}
            loadError={loadError}
          />
        </div>

        <div className="col-lg-6 col-sm-12">
          <div className="card bg-light" style={{ minHeight: '4rem' }}>
            <div className="card-body">
              <div className="pb-3 text-danger">
                There was an issue accessing your quote. Please try again.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

UnexpectedErrorQuoteScreen.propTypes = {
  quote: PropTypes.shape(CrmQuote).isRequired,
  loadError: PropTypes.bool.isRequired,
};

export default UnexpectedErrorQuoteScreen;
